import { isRunningHubListThumbUrl } from './runningHubHistoryLocalStorage';

/** 历史列表项中可用于预览图的字段（只读解析，不写库） */
export type RunningHubHistoryListImageFields = {
  thumbUrl?: string;
  upscaledUrl?: string;
  resultSnapshot?: string;
  urls?: string[];
};

export function isRunningHubHistoryListDisplayUrl(raw: unknown): boolean {
  if (typeof raw !== 'string') return false;
  const s = raw.trim();
  if (!s) return false;
  return /^https?:\/\//i.test(s) || /^data:image\//i.test(s) || /^blob:/i.test(s);
}

/** 无 thumb 时的结果图回退：upscaledUrl → resultSnapshot → urls[] */
export function pickRunningHubHistoryFallbackResultUrl(item: RunningHubHistoryListImageFields): string | null {
  const candidates: unknown[] = [item.upscaledUrl, item.resultSnapshot];
  if (Array.isArray(item.urls)) {
    for (const u of item.urls) candidates.push(u);
  }
  for (const c of candidates) {
    if (isRunningHubHistoryListDisplayUrl(c)) return String(c).trim();
  }
  return null;
}

export type RunningHubHistoryListImageSource = {
  url: string;
  kind: 'thumb' | 'fallback';
};

/** 列表预览优先级：thumbUrl → 结果图 fallback */
export function pickRunningHubHistoryListImageSrc(
  item: RunningHubHistoryListImageFields,
): RunningHubHistoryListImageSource | null {
  if (isRunningHubListThumbUrl(item.thumbUrl)) {
    return { url: String(item.thumbUrl).trim(), kind: 'thumb' };
  }
  const fallback = pickRunningHubHistoryFallbackResultUrl(item);
  if (fallback) return { url: fallback, kind: 'fallback' };
  return null;
}
